module.exports = __webpack_public_path__ + "img/icon_followers_2.e931900f.png";